/**
 * @param {string} namepace
 * @param {Record<string, string>} object
 * @return {Record<string, string>}
 * @throws Не указано пространство имён или объект с переводами
 */
export function setLocaleObjectNamespace(namepace, object = {}) {
    if (!namepace) {
        throw new Error("Укажите пространство имён для объекта с переводами!");
    }

    const entries = Object.entries(object);

    if (!entries.length) {
        throw new Error("Объект с переводами пуст или не передан!");
    }

    return entries.reduce((acc, [key, value]) => {
        acc[`${namepace}.${key}`] = value;

        return acc;
    }, {});
}
